// Generated by scripts/generate-city-builder-price-contract.mjs; do not edit.
(function (global) {
  'use strict';
  global.NF_CITY_PRICE_CONTRACT = Object.freeze({
  "schema_version": "nf-city-price-contract/1.0.0",
  "contract_version": "nf-city-pricing/2026-09-22",
  "currency": "DKK",
  "sizes": {
    "22": {
      "base_minor": {
        "hvid": 49900,
        "farve": 59900
      },
      "frame_surcharge_minor": {
        "uden": 0,
        "klassisk": 14900,
        "pro": 24900
      },
      "totals_minor": {
        "hvid|uden|ingen": 49900,
        "farve|uden|ingen": 59900,
        "hvid|med|klassisk": 64800,
        "farve|med|klassisk": 74800,
        "hvid|med|pro": 74800,
        "farve|med|pro": 84800
      }
    },
    "44": {
      "base_minor": {
        "hvid": 149900,
        "farve": 169900
      },
      "frame_surcharge_minor": {
        "uden": 0,
        "klassisk": 69900,
        "pro": 99900
      },
      "totals_minor": {
        "hvid|uden|ingen": 149900,
        "farve|uden|ingen": 169900,
        "hvid|med|klassisk": 219800,
        "farve|med|klassisk": 239800,
        "hvid|med|pro": 249800,
        "farve|med|pro": 269800
      },
      "product": {
        "id": "12287400247560",
        "handle": "bykort-personlig-44x44",
        "variants": {
          "hvid|uden|ingen": "58823483949320",
          "farve|uden|ingen": "58823483982088",
          "hvid|med|klassisk": "58823484014856",
          "farve|med|klassisk": "58823484047624",
          "hvid|med|pro": "58823484080392",
          "farve|med|pro": "58823484113160"
        }
      }
    }
  }
});
})(globalThis);
